import { StyledButton } from '../../utils/theme';

interface BackButtonProps {
  onClick: () => void;
}

const BackButton = ({ onClick }: BackButtonProps) => {
  return (
    <StyledButton onClick={onClick}>
      戻る
    </StyledButton>
  );
};

export default BackButton;
